import { type FC } from 'react'

import { useNavigate } from 'react-router'

import EbookAndWebinar from '@/assets/images/christmas/e-book-and-webinar.png'
import ChristmasLine from '@/assets/images/christmas/line-short.png'
import { Dialog } from '@/components/ui/dialog.tsx'
import type { DialogProps } from '@/dialogs/types'
import { CampaignPromotionButton } from '@/modules/campaigns/components/promotion-button.tsx'
import { AppRoutes } from '@/utils/constants.ts'

import { ChristmasOfferPromotionDialogAnimation } from './animation.tsx'

interface Props extends DialogProps {}

export const ChristmasPromotionDialog: FC<Props> = ({ isOpen, onClose }) => {
  const navigate = useNavigate()

  const handleClickUpgrade = () => {
    navigate(AppRoutes.Licenses.YourLicenses.asUrl())
    onClose()
  }

  const handleClickNewLicense = () => {
    navigate(AppRoutes.Licenses.Index.asUrl())
    onClose()
  }

  return (
    <Dialog
      bigDialog
      show={isOpen}
      onClose={onClose}
      panelClassName="border-none lg:max-w-[710px] sm:max-w-[710px] sm:p-12 p-8 rounded-2xl bg-[radial-gradient(50%_50%_at_50%_50%,#0F0662_0%,#0C0D11_100%)]"
      closeIconClassName="p-2 rounded-full bg-white/10 [&_svg]:text-white [&_svg]:h-6 [&_svg]:w-6 h-10 w-10"
      containerClassName="items-center"
    >
      <div className="relative mx-auto max-w-[495px] pt-[205px]">
        <ChristmasOfferPromotionDialogAnimation />
        <div className="relative z-10">
          <p className="text-center text-[60px] font-bold leading-[60px] text-white sm:text-[96px] sm:leading-[89px] [@media(max-height:860px)]:text-[60px] [@media(max-height:860px)]:leading-[60px]">
            Christmas Offer!
          </p>
          <p className="mt-4 text-center text-base font-medium text-white sm:text-lg">
            Take advantage of our Christmas Offer to supercharge your earnings
            over the holidays.
          </p>
          <div className="mt-4 overflow-hidden rounded-2xl bg-secondary-700 sm:mt-8">
            <img
              src={ChristmasLine}
              alt="Christmas Line"
              className="h-1.5 w-full"
            />
            <div className="flex items-center gap-8 p-4 sm:p-6">
              <img
                src={EbookAndWebinar}
                alt="Ebook and Webinar"
                className="w-[80px]"
              />
              <p className="max-w-[300px] text-base font-medium text-white sm:text-lg">
                Get a free E-Book and Webinar via E-Mail with our Christmas
                Offer!
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="mt-4 flex flex-col gap-3 sm:mt-8 sm:flex-row [@media(min-height:860px)]:mt-[56px]">
        <CampaignPromotionButton
          variant="transparent"
          onClick={handleClickUpgrade}
        >
          Upgrade License
        </CampaignPromotionButton>
        <CampaignPromotionButton
          variant="white"
          onClick={handleClickNewLicense}
        >
          New License
        </CampaignPromotionButton>
      </div>
    </Dialog>
  )
}
